// eslint-disable-next-line no-restricted-imports
import { Modal } from "antd";
import { useModal } from "@/shared/modal";
import { Result } from "@/shared/feedback/result";
import { SignStatusIcon } from "@/modules/signing/shared/ui/sign-status-icon/sign-status-icon";
import { FileSyncOutlined } from "@ant-design/icons";
import { usePalette } from "@/shared/theme";
import Button from "@/shared/form/button";
import Text from "@/shared/typography/text";
import { useTranslations } from "use-intl";

export function WelcomeModal() {
  const t = useTranslations("Signing");
  const palette = usePalette();
  const { openModal, close } = useModal({ initValue: true });

  return (
    <Modal
      centered
      open={openModal}
      onCancel={close}
      footer={null}
      closeIcon={null}
      styles={{
        content: {
          padding: "40px",
        },
      }}
    >
      <Result
        className={"!p-0"}
        icon={
          <div className={"flex justify-center"}>
            <SignStatusIcon
              icon={<FileSyncOutlined />}
              iconColor={palette.neutral[8]}
              iconBackgroundColor={palette.neutral[1]}
              iconSecondaryBackgroundColor={palette.neutral[0]}
            />
          </div>
        }
        title={
          <Text as={"span"} type={"headline1"} medium>
            {t("EXTERNAL_SIGNING_WELCOME_TITLE")}
          </Text>
        }
        subTitle={
          <Text as={"span"} color={"secondary"}>
            {t("EXTERNAL_SIGNING_WELCOME_SUBTITLE")}
          </Text>
        }
        extra={
          <Button
            type={"primary"}
            onClick={close}
            data-testid={"external-sign-welcome-close"}
          >
            {t("EXTERNAL_SIGNING_WELCOME_OK")}
          </Button>
        }
      />
    </Modal>
  );
}
